'use client'; // Error components must be Client Components

import {useEffect} from 'react';
import Container from '@/components/layout/container';
import Button from '@/components/button';
import Heading from '@/components/typography/heading';
import {Box} from '@/components/layout/box';
import styles from './error.module.scss';
import {Flex} from '@/components/layout/flex';
import Card from '@/components/card';
import Text from '@/components/typography/text';

interface TitlePageErrorProps {
  error: Error & { digest?: string; };
  reset: () => void;
}

export default function TitlePageError({
  error,
  reset,
}: TitlePageErrorProps) {

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <Container>
      <Flex justify='center' align='center' mt={10} mb={10}>
        <Card className={styles.errorCard} p={1}>
          <Heading as='h2' size='medium' align='center' mb={0.5}>Something went wrong</Heading>
          <Text align='center' mb={1} color='copy'>Please try again</Text>
          <Flex justify='center' align='center'>
            <Box className={styles.buttonContainer}>
              <Button
                text='Try again'
                onPress={reset}
              />
            </Box>
          </Flex>
        </Card>
      </Flex>
    </Container>
  );
}